import { render, staticRenderFns } from "./ImportAni.vue?vue&type=template&id=9a89a006&scoped=true&"
import script from "./ImportAni.vue?vue&type=script&lang=js&"
export * from "./ImportAni.vue?vue&type=script&lang=js&"
import style0 from "./ImportAni.vue?vue&type=style&index=0&id=9a89a006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a89a006",
  null
  
)

component.options.__file = "ImportAni.vue"
export default component.exports